// Generated by ts-to-zod
import { z } from "zod";

export const approvalTypeSchema = z.union([
  z.literal("Standard"),
  z.literal("Permit"),
  z.literal("Permit2"),
]);

export const gasFeeResponseSchema = z.object({
  native: z.string(),
  usd: z.number().optional().nullable(),
});

export const minSizeFeeSchema = z.object({
  ether: z.number(),
  usd: z.number(),
});

export const quoteToSignApiResponseSchema = z.object({
  expiry: z.number(),
  taker_address: z.string(),
  maker_addresses: z.array(z.string()),
  maker_nonces: z.array(z.number()),
  taker_tokens: z.array(z.array(z.string())),
  maker_tokens: z.array(z.array(z.string())),
  taker_amounts: z.array(z.array(z.string())),
  maker_amounts: z.array(z.array(z.string())),
  receiver: z.string(),
  commands: z.string(),
});

export const responseBuyTokenSchema = z.object({
  amount: z.string(),
  decimals: z.number(),
  priceUsd: z.number(),
  symbol: z.string(),
  price: z.number().optional().nullable(),
  priceBeforeFee: z.number().optional().nullable(),
  amountBeforeFee: z.string(),
});

export const responseSellTokenSchema = z.object({
  amount: z.string(),
  decimals: z.number(),
  priceUsd: z.number(),
  symbol: z.string(),
  price: z.number().optional().nullable(),
  priceBeforeFee: z.number().optional().nullable(),
});

export const routeTypeSchema = z.union([z.literal("PMM"), z.literal("Jam")]);

export const toSignSchema = z.object({
  taker: z.string(),
  receiver: z.string(),
  expiry: z.number(),
  nonce: z.string(),
  executor: z.string(),
  minFillPercent: z.number(),
  hooksHash: z.string(),
  sellTokens: z.array(z.string()),
  buyTokens: z.array(z.string()),
  sellAmounts: z.array(z.string()),
  buyAmounts: z.array(z.string()),
  sellNFTIds: z.array(z.string()),
  buyNFTIds: z.array(z.string()),
  sellTokenTransfers: z.string(),
  buyTokenTransfers: z.string(),
});

export const txDataSchema = z.object({
  from: z.string().nullable(),
  to: z.string(),
  value: z.string(),
  data: z.string(),
  gas: z.number().nullable(),
  gasPrice: z.number().nullable(),
});

export const validationErrorSchema = z.object({
  loc: z.array(z.union([z.string(), z.number()])),
  msg: z.string(),
  type: z.string(),
});

export const apiErrorSchema = z.object({
  errorCode: z.number(),
  message: z.string().optional().nullable(),
  fee: minSizeFeeSchema.optional().nullable(),
});

export const commonApiJamApiTypesQuoteResponseSchema = z.object({
  type: z.string(),
  status: z.string(),
  quoteId: z.string(),
  chainId: z.number(),
  approvalType: approvalTypeSchema,
  nativeToken: z.string(),
  taker: z.string(),
  receiver: z.string(),
  expiry: z.number(),
  gasFee: gasFeeResponseSchema,
  buyTokens: z.record(responseBuyTokenSchema),
  sellTokens: z.record(responseSellTokenSchema),
  settlementAddress: z.string(),
  approvalTarget: z.string(),
  requiredSignatures: z.array(z.string()),
  referralFeeNative: z.number().optional().nullable(),
  hooksHash: z.string(),
  toSign: toSignSchema,
  solver: z.string(),
});

export const errorResponseSchema = z.object({
  error: apiErrorSchema,
  routeErrors: z.record(apiErrorSchema).optional().nullable(),
});

export const hTTPValidationErrorSchema = z.object({
  detail: z.array(validationErrorSchema).optional(),
});

export const quoteApiResponseSchema = z.object({
  type: z.string(),
  status: z.string(),
  quoteId: z.string(),
  chainId: z.number(),
  approvalType: approvalTypeSchema,
  nativeToken: z.string(),
  taker: z.string(),
  receiver: z.string(),
  expiry: z.number(),
  gasFee: gasFeeResponseSchema,
  buyTokens: z.record(responseBuyTokenSchema),
  sellTokens: z.record(responseSellTokenSchema),
  settlementAddress: z.string(),
  approvalTarget: z.string(),
  requiredSignatures: z.array(z.string()),
  referralFeeNative: z.number().optional().nullable(),
  toSign: quoteToSignApiResponseSchema,
  tx: txDataSchema.optional().nullable(),
});

export const routeQuoteSchema = z.object({
  type: routeTypeSchema,
  quote: z.union([commonApiJamApiTypesQuoteResponseSchema, quoteApiResponseSchema]),
});

export const routerApiApiTypesQuoteResponseSchema = z.object({
  routes: z.array(routeQuoteSchema),
  errors: z.record(apiErrorSchema),
});
